import React from "react";
import { RemoveCircleOutline } from "@mui/icons-material";
import { useSimpleFormIteratorItem } from "react-admin";

type DeleteMemberProps = {
  onClick: (id: number) => void;
};

const DeleteMember: React.FC<DeleteMemberProps> = ({ onClick }) => {
  const { index } = useSimpleFormIteratorItem();

  return <RemoveCircleOutline onClick={() => onClick(index)} />;
};

export default DeleteMember;
